import React from 'react';
import classNames from 'classnames';
import {SectionTilesProps} from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from "../elements/Image";

const propTypes = {
    ...SectionTilesProps.types
}

const defaultProps = {
    ...SectionTilesProps.defaults
}

const UsageSection = ({
                          className,
                          topOuterDivider,
                          bottomOuterDivider,
                          topDivider,
                          bottomDivider,
                          hasBgColor,
                          invertColor,
                          pushLeft,
                          ...props
                      }) => {

    const outerClasses = classNames(
        'testimonial section',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'testimonial-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
        'tiles-wrap',
        pushLeft && 'push-left'
    );

    const sectionHeader = {
        title: '1日の流れ',
        paragraph: null

    };

    return (
        <section
            {...props}
            className={outerClasses}
        >
            <div className="container">
                <div className={innerClasses}>
                    <SectionHeader data={sectionHeader} className="center-content"/>
                    <div className={tilesClasses}>

                        <div className="reveal-from-right mr-4" data-reveal-delay="200">
                            <Image
                                src={require('./../../assets/images/usage/schedule_common.png')}
                                alt="Mentor's avatar"
                                width={300}
                                height={'auto'}/>
                        </div>

                        <div className="reveal-from-right ml-4" data-reveal-delay="200">
                            <Image
                                src={require('./../../assets/images/usage/schedule_wed.png')}
                                alt="Mentor's avatar"
                                width={300}
                                height={'auto'}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

UsageSection.propTypes = propTypes;
UsageSection.defaultProps = defaultProps;

export default UsageSection;